<mojo-widget [title]="widget.title" [showWidgetControls]="true" [widget]="widget">
  <ng-container widget-control-section>
    <mojo-dbw-print-btn widget-control-section title="Print">
      <ng-template #printTemplate>
        <mojo-tenancy-schedule-print-layout
        *ngIf="printData$ | async as printData"
          [printData]="printData"
          [footerValues]="footerValues$ | async"
          [context]="context"
          mojoPrintImmediate
          [headCss]="css"
          [displayHeader]="false">
        </mojo-tenancy-schedule-print-layout>
      </ng-template>
    </mojo-dbw-print-btn>
    <a alt="Edit Filter" (click)="filterDialog.showFilterDialog(currentFilter)" class="btn active filter" title="Advanced Filter">
      <span class="fa fa-stack">
        <i class="fa fa-filter fa-stack-1x fa-lg"></i>
        <i *ngIf="hasCustomFilter" class="fa fa-check fa-stack-1x custom-filter"></i>
        
      </span>
    </a>
  </ng-container>
  <ng-container widget-body>
    <div class="row full-height overflow-hidden">
      <mojo-list-widget-table
        #dataTable
        tableTitle=""
        [showPaginator] = "false"
        [loading]="loading$ | async"
        [table]="table$ | async"
        [availableColumns]="availableColumns$ | async"
        (selectedColumnsChanged)="dialogSaved($event)"
        (onColReorder)="columnsReordered($event)"
        (resetColumns)="resetColumns()"
        (onColResize)="columnsResized($event)">
      </mojo-list-widget-table>
    </div>
  </ng-container>
</mojo-widget>

<mojo-filter-editor-dialog #filterDialog (onSaveFilter)="filterEdited($event)" [queryConfig]="queryConfig | async" [sysAdminFilterText]="sysAdminFilterText$ | async"></mojo-filter-editor-dialog>
